import React from 'react';
import { Checkbox } from "@/components/ui/checkbox";

// Optional Google Ads consent (unchecked by default): ticked = ad_user_data_consent GRANTED for this lead
export const AdsConsentCheckbox = ({ id, checked, onChange, dark = false }) => (
  <div className="flex items-start gap-3" data-testid={`${id}-block`}>
    <Checkbox
      id={id}
      checked={!!checked}
      onCheckedChange={(c) => onChange(c === true)}
      className="h-5 w-5 mt-0.5 border-2 border-gray-300 data-[state=checked]:bg-green-600 data-[state=checked]:border-green-600 cursor-pointer flex-shrink-0"
      data-testid={`${id}-checkbox`}
    />
    <label htmlFor={id} className={`text-xs leading-relaxed cursor-pointer select-none ${dark ? 'text-gray-400' : 'text-gray-500'}`}>
      J'accepte que ma demande soit partagée avec Google Ads pour mesurer nos annonces
    </label>
  </div>
);
